var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResources = function SvgResources(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M12 44h30v-4H12.024C11.1 39.976 10 39.61 10 38s1.1-1.976 2.024-2H42V8c0-2.206-1.794-4-4-4H12c-2.412 0-6 1.598-6 6v28c0 4.402 3.588 6 6 6m-2-28v-6c0-1.61 1.1-1.976 2-2h26v24H10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M16 12h18v4H16z"
  })));
};
export { SvgResources as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDQ0SDQyVjQwSDEyLjAyNEMxMS4xIDM5Ljk3NiAxMCAzOS42MSAxMCAzOEMxMCAzNi4zOSAxMS4xIDM2LjAyNCAxMi4wMjQgMzZINDJWOEM0MiA1Ljc5NCA0MC4yMDYgNCAzOCA0SDEyQzkuNTg4IDQgNiA1LjU5OCA2IDEwVjM4QzYgNDIuNDAyIDkuNTg4IDQ0IDEyIDQ0Wk0xMCAxNlYxMEMxMCA4LjM5IDExLjEgOC4wMjQgMTIgOEgzOFYzMkgxMFYxNloiIGZpbGw9IiM5MDlBOUYiLz4KPHBhdGggZD0iTTE2IDEySDM0VjE2SDE2VjEyWiIgZmlsbD0iIzkwOUE5RiIvPgo8L3N2Zz4K";